import { APIUrlConstants, AppConstants } from "../../../common/APIConstants";
import RestEndPoint from "../../../common/RestEndPoint";
export default class GainLossListsScreenAPI {
  static getEntityTypes(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetEntityTypes,
      "GET",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }

  static getEntityList(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetEntityList,
      "POST",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }

  static createEntity(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.CreateEntity,
      "POST",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }

  static updateEntity(listId, data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.UpdateEntity.replace("{listId}", listId),
      "PUT",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
}
